
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { isError } from "../../state/helpers/Error"
import { INTEGRATION_KEY } from "../../state/integration/Constants"
import { ProcessedPaymentDto } from "../model/ProcessedPayment"

type PaymentsCount = {
	totalPaymentsCount: number
}

class PaymentProcessingService {

    static async getPaymentsCount(merchantId: string, integrationKey: INTEGRATION_KEY): Promise<PaymentsCount> {
        const res = await AppContext.getApiClient().get(`/${integrationKey}/merchants/${merchantId}/processed-payments-count`)
        if (isError(res)) {
            throw new Error(res.message)
        }
        return res as PaymentsCount
    }


    static async getProcessedPaymentsByPaymentIds(paymentIds: string[]): Promise<ProcessedPaymentDto[]> {
        const res = await AppContext.getApiClient().post("/search/processed-payments", {
            paymentIds,
        })

        if (isError(res)) {
            throw new Error(res.message)
        }
        
        return res as ProcessedPaymentDto[]
    }
}

export default PaymentProcessingService


// WEBPACK FOOTER //
// ./src/payment-account/service/paymentprocessingService.ts